






















import { ICurrency } from "@/models/constants";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class UPriceConvertedTooltip extends Vue {
  // Props
  @Prop({ default: 0 })
  public xr!: number;
  @Prop({ default: "" })
  public convertedCurrency!: ICurrency["code"];
  @Prop({ default: "" })
  public baseCurrency!: ICurrency["code"];
}
